import { http } from '@/core/helpers/axiosHelper';
import { Fulltime } from './fulltime.interface';

export class FulltimeService {
   async postFulltime(companyJointCommitteeId: number, fulltime: Fulltime) {
      return await http
         .post(`/company-joint-committee/${companyJointCommitteeId}/fulltimes`, fulltime, { params: { append: 'scopes' } })
         .then((response) => response.data);
   }

   async putFulltime(companyJointCommitteeId: number, fulltimeId: number, fulltime: Fulltime) {
      return await http
         .put(`/company-joint-committee/${companyJointCommitteeId}/fulltimes/${fulltimeId}`, fulltime, { params: { append: 'scopes' } })
         .then((response) => response.data);
   }

   async deleteFulltime(companyJointCommitteeId: number, fulltimeId: number) {
      return http
         .delete(`/company-joint-committee/${companyJointCommitteeId}/fulltimes/${fulltimeId}/erase`)
         .then((response) => response.data);
   }

   async archiveFulltime(companyJointCommitteeId: number, fulltimeId: number) {
      return http.delete(`/company-joint-committee/${companyJointCommitteeId}/fulltimes/${fulltimeId}`).then((response) => response.data);
   }

   async restoreFulltime(companyJointCommitteeId: number, fulltimeId: number) {
      return http
         .patch(`/company-joint-committee/${companyJointCommitteeId}/fulltimes/${fulltimeId}/restore`)
         .then((response) => response.data);
   }
}
